import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { Reveal } from '../components/Reveal';
import { Button } from '../components/Button';
import { PartnersSection } from '../components/PartnersSection';
import { EmployerCta } from '../components/EmployerCta';
import { images, workingPrinciples } from '../data/content';
export function About() {
  return <>
      <PageHeader label="About Us" title="Focused on people. Aligned with opportunity." intro="Rising Talent Partners is an executive search and recruitment firm connecting organizations with experienced professionals." image={{
      src: images.about,
      alt: 'Two professionals in a one-to-one conversation in a quiet office'
    }} data-id="element-319" data-mp="328kegj4wt8pf" />

      <section className="bg-white py-24 lg:py-32" data-id="element-320" data-mp="2x7d88oif0hkv">
        <div className="mx-auto grid max-w-7xl gap-10 px-6 lg:grid-cols-12 lg:gap-12 lg:px-10" data-id="element-321" data-mp="1gug8kc2s86q7">
          <Reveal className="lg:col-span-5" data-id="element-322" data-mp="1lukj7lh0e78i">
            <span className="block h-px w-12 bg-gold" aria-hidden="true" data-id="element-323" data-mp="1lvcfkyifk8zu" />
            <h2 className="mt-6 font-serif text-4xl font-medium leading-[1.1] text-navy sm:text-5xl" data-id="element-324" data-mp="1uil35ftv4aie">
              What we do
            </h2>
          </Reveal>
          <Reveal delay={0.05} className="space-y-6 text-lg leading-relaxed text-ink/75 lg:col-span-6 lg:col-start-7" data-id="element-325" data-mp="23i87a9dz7uf5">
            <p data-id="element-326" data-mp="1yj3wjebelomp">
              We work with organizations that need to hire experienced professionals for senior,
              leadership, and specialist roles, and with professionals considering their next
              career move.
            </p>
            <p data-id="element-327" data-mp="28fgp28v7pwfv">
              Our work centers on understanding role requirements in depth, identifying relevant
              professionals in the talent market, and facilitating meaningful, well-matched
              introductions between employers and candidates.
            </p>
            <div className="flex flex-col gap-3 pt-4 sm:flex-row" data-id="element-328" data-mp="2w7njv3lahvd6">
              <Button to="/services" data-id="element-329" data-mp="2r8u577u9nybf">Our Services</Button>
              <Button to="/contact" variant="outline" data-id="element-330" data-mp="2r67vp2ntf8qk">
                Contact Us
              </Button>
            </div>
          </Reveal>
        </div>
      </section>

      <section aria-labelledby="principles-heading" className="bg-mist py-24 lg:py-32" data-id="element-331" data-mp="1swrfujhpw140">
        <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-332" data-mp="1xujb9nhkm5cy">
          <Reveal className="max-w-2xl" data-id="element-333" data-mp="22lrlumumzwrp">
            <span className="block h-px w-12 bg-gold" aria-hidden="true" data-id="element-334" data-mp="22nm5lxu69iu7" />
            <h2 id="principles-heading" className="mt-6 font-serif text-4xl font-medium leading-[1.1] text-navy sm:text-5xl" data-id="element-335" data-mp="27lxeo6cn7pbd">
              How we work
            </h2>
          </Reveal>
          <ul className="mt-14 grid gap-10 border-t border-gold/40 pt-10 md:grid-cols-3 md:gap-12" data-id="element-336" data-mp="2glasfb7sv01w">
            {workingPrinciples.map((p, i) => <li key={p.title} data-id="element-337" data-mp="2lk44r0bcol0h" data-mpi={i}>
                <Reveal delay={i * 0.05} data-id="element-338" data-mp="m81dh3whimc9">
                  <h3 className="font-serif text-[26px] font-medium leading-tight text-navy" data-id="element-339" data-mp="m93085mv4x9t">{p.title}</h3>
                  <p className="mt-3 leading-relaxed text-ink/70" data-id="element-340" data-mp="r7eauikzfbt3">{p.body}</p>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </section>

      <div className="pt-0" data-id="element-341" data-mp="evlonulm4m0a">
        <PartnersSection data-id="element-342" data-mp="evbwq1h0c4ry" />
      </div>
      <EmployerCta data-id="element-343" data-mp="9xaetjvbibi2" />
    </>;
}